const UserStatus = Object.freeze({
    NEW: 'NEW',
    EXISTING: 'EXISTING',
});

export default UserStatus;
